import { render, staticRenderFns } from "./CommonSwiper.vue?vue&type=template&id=7b27a0d3&scoped=true&"
import script from "./CommonSwiper.vue?vue&type=script&lang=js&"
export * from "./CommonSwiper.vue?vue&type=script&lang=js&"
import style0 from "./CommonSwiper.vue?vue&type=style&index=0&id=7b27a0d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b27a0d3",
  null
  
)

export default component.exports